export const encodeUri = (value: string) => {
    try {
        const encodedValue = encodeURIComponent(value);
        return encodedValue;
    } catch {
        return value;
    }
};

export const decodeUri = (value: string) => {
    try {
        const decodedValue = decodeURIComponent(value);
        return decodedValue;
    } catch {
        return value;
    }
};
